import React, { useEffect, useState } from "react";
import { MenuItem } from "@mui/material";

import KogModalSideComponent from "@/main/components/modal/ModalSide";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import AccordionQuoteHistory from "@/main/components/shared/accordionQuoteHistory/accordionQuoteHistory";
import { Controls } from "@/main/services/constants/constantsControl";
import {
	getGuidScreenByRoute,
	getTranslateByKey,
	isNullUndefined,
	isShowControlByElementId,
} from "@/main/services/utils";

import * as S from "../styles";
import { KeyValue } from "@/main/models/common";
import AccordionHistory from "@/main/screens/order/viewOrder/components/modalHistory/accordionHistory/accordionHistory";
import { useThreeDotsClaimContext } from "../contex";
import { RoutesConstants } from "@/main/routes/routesConstants";

interface IThreeDotsClaimHistoryProps {
	quotes: KeyValue[];
	procurements: KeyValue[];
}
function ThreeDotsClaimHistory({ quotes, procurements }: IThreeDotsClaimHistoryProps) {
	const { closeThreeDotsClaim, generateIdMenu } = useThreeDotsClaimContext();
	const [modalHistory, setModalHistory] = useState<boolean>(false);
	const showPrices = isShowControlByElementId(Controls.IdShowPrices);
	const [currentCollapse, setCurrentCollapse] = useState<string | false>(false);
	const guidScreen = getGuidScreenByRoute(RoutesConstants.claimSearchClaims);

	function handleClick() {
		setModalHistory(true);
		closeThreeDotsClaim();
	}
	function closeModal() {
		setModalHistory(false);
	}

	useEffect(() => {
		setModalHistory(false);
	}, []);

	// Core function
	const handleChangeCollapse = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
		event.stopPropagation();
		event.preventDefault();
		setCurrentCollapse(isExpanded ? panel : false);
	};

	return (
		<>
			<MenuItem id={generateIdMenu("history")} onClick={handleClick}>
				{getTranslateByKey("information.history")}
			</MenuItem>
			{modalHistory && (
				<KogModalSideComponent
					open={modalHistory}
					closeModal={() => closeModal()}
					title={getTranslateByKey("information.history")}
				>
					<S.ContentAccordionQuoteHistory>
						{procurements.map((procurement) => (
							<AccordionHistory
								key={procurement.value}
								showPrices={showPrices}
								guidProcurement={String(procurement.key)}
								title={`${getTranslateByKey("information.order")}${isNullUndefined(procurement.value) ? "" : ` - ${procurement.value}`}`}
								propsCollapse={{
									expanded: currentCollapse === "panel1" + procurement.value,
									onChange: handleChangeCollapse("panel1" + procurement.value),
								}}
							/>
						))}
						{quotes.map((quote) => (
							<AccordionQuoteHistory
								key={quote.key}
								isCollapse={true}
								showPrices={showPrices}
								guidQuote={String(quote.key)}
								name={quote.value}
								guidScreen={guidScreen}
								propsCollapse={{
									expanded: currentCollapse === "panel2" + quote.value,
									onChange: handleChangeCollapse("panel2" + quote.value),
								}}
							/>
						))}
					</S.ContentAccordionQuoteHistory>
					<S.FooterButtonHistory>
						<SecondaryButton id="id-createOrder-button-back" onClick={() => closeModal()}>
							{getTranslateByKey("information.back")}
						</SecondaryButton>
					</S.FooterButtonHistory>
				</KogModalSideComponent>
			)}
		</>
	);
}

export { ThreeDotsClaimHistory };
